import { Form } from 'antd'
import { TBankAccountForm, TBankAccountFormErrors } from '../../types'
import { useCallback, useState } from 'react'
import { setLoading } from 'redux/store/common/slice'
import { useDispatch } from 'react-redux'
import { updateBankAccountDetails } from '../../api'
import { useBankAccountDetailsContext } from '../Providers/BankAccountDetailsContextProvider'
import { AxiosResponse } from 'axios'

export const useBankAccountDetailsForm = () => {
  const [form] = Form.useForm<TBankAccountForm>()
  const [errors, setErrors] = useState<TBankAccountFormErrors>({})
  const [isActive, setIsActive] = useState(false)

  const {
    state: { details, moovBusinessAccountId },
    actions: { getDetails }
  } = useBankAccountDetailsContext()

  const dispatch = useDispatch()

  const onFormChange = useCallback(() => {
    setIsActive(true)
  }, [setIsActive])

  const onFinish = useCallback(async () => {
    if (!moovBusinessAccountId || !details?.uuid) return
    try {
      dispatch(setLoading(true))
      const data = form.getFieldsValue()

      await updateBankAccountDetails(moovBusinessAccountId, details.uuid, data)

      setIsActive(false)
      setErrors({})

      await getDetails()
    } catch (error) {
      const e = error as AxiosResponse
      setErrors(e.data)
      console.error(error)
    } finally {
      dispatch(setLoading(false))
    }
  }, [details?.uuid, dispatch, form, getDetails, moovBusinessAccountId])

  return {
    form,
    errors,
    setErrors,
    isActive,
    setIsActive,
    onFormChange,
    onFinish
  }
}
